<template>
  <div>
    <nav-header
      id="special_head"
      ref="navHeader"
      v-bind:showSearch="p_showSearch"
      v-bind:loginModalFlag="p_loginModalFlag"
      v-bind:showNavbar="p_showNavbar"
      v-bind:showCart="p_showCart"
      v-on:showLoginModal="p_showLoginModal"
      v-on:closeLoginModal="p_closeLoginModal">
    </nav-header>
    <nav-bread>
      <span slot="goods">全部商品</span>
      <span slot="detail">商品详情</span>
    </nav-bread>
    <div class="container" v-loading="loading">
      <div class="banner">
        <el-row>
          <el-col :span="12" class="left">
            <!--轮播-->
            <el-carousel class="myCaro" :interval="5000" arrow="always" :height="bannerHeight + 'px'" v-if="items.length > 1">
              <el-carousel-item v-for="(item, index) in items" :key="item">
                <img ref="bannerHeight" class="detPic" :src="item" :alt="'检验网'+ prodoctInfo.itemName" @load="imgLoad">
              </el-carousel-item>
            </el-carousel>
            <div class="myCaro" v-if="items.length == 1">
              <img class="detPic" :src="items[0]" :alt="'检验网'+ prodoctInfo.itemName">
            </div>
          </el-col>
          <el-col :span="12" class="right">
            <div class="decMain">
              <p><a herf="javascript:;" class="providerName">{{prodoctInfo.providerName}}
              </a></p>
              <p class="itemname">{{prodoctInfo.itemName}}</p><span style="color:#FE2042;padding-left:20px" v-if="prodoctInfo.status == 2 || prodoctInfo.status == 0">(已下架)</span>
              <p class="itemprice">￥{{(groupInfo && groupInfo.groupPrice ? groupInfo.groupPrice : prodoctInfo.price) * specNumber | FormatCurrency((groupInfo && groupInfo.groupPrice ? groupInfo.groupPrice : prodoctInfo.price) * specNumber)}}<span>市场指导价：￥{{prodoctInfo.originalPrice}}</span></p><!--TODO-->

              <!-- 领取优惠券 非个人和拼团不参与-->
              <!-- <div class='coupons' @click='showCouponModal' v-if='itemcouponsList.length&&isChannel!=1&&isChannel!=2'> -->
              <div class='coupons' @click='couponsDetailHandle(prodoctInfo.id)' v-if="itemcouponsList.length!==0 && user.isChannel === 0 && !groupGoods">
                <div class='coupons_wrap'>
                  <span class='coupon_txt'>优惠券:</span>
                  <div class='coupon_item_wrap'>
                    <div class='coupon_item' v-if="itemcouponsList.length===1" v-for='(item, index) in itemcouponsList'>
                      <div v-if='item.couponType == 0'>{{item.title}}满{{item.amount}}减{{item.value}}</div>
                      <div v-else>{{item.title}}满{{item.amount}}享{{discountCoupon(item.value,10)}}折</div>
                    </div>
                    <div class='coupon_item' v-if="itemcouponsList.length!==1" v-for='(item, index) in itemcouponsList.slice(0, 2)'>
                      <div v-if='item.couponType == 0'>{{item.title}}满{{item.amount}}减{{item.value}}</div>
                      <div v-else>{{item.title}}满{{item.amount}}享{{discountCoupon(item.value,10)}}折</div>
                    </div>
                  </div>
                  <div v-if="itemcouponsList.length > 1" style="color:red;margin-right:5px;">...</div>
                  <span class='coupon_txt'>领取 >></span>
                </div>
                <!-- <img class='coupon_img' src='../../imgs/more.png'> -->
              </div>

              <div class="check checktitle">
                <span class="check-title" v-if="itemSpecList.length">商品规格:</span>
                <div style="display:inline-block;margin-left:20px;">
                  <el-radio-group v-model="checkedSpecId" @change="checkItemSpec">
                  <span v-for="item in itemSpecList" :label="item.name" :key="item.id" style="margin-right: 20px;">
                    <el-radio-button :label="item.id">{{item.spec}}</el-radio-button>
                  </span>
                  </el-radio-group>
                </div>
              </div>
              <div class="check">
                <span class="check-attention">【注意事项】</span>
                <el-checkbox-group
                  v-model="checkExInfoList">
                  <el-checkbox class="info" v-for="exInfo in exInfoList" :label="exInfo.name" :key="exInfo.id" @change="NoteIds(exInfo.id)">
                    {{exInfo.name}}
                  </el-checkbox>
                </el-checkbox-group>
                <p class="agreement" v-if="prodoctInfo.type != 2">
                  <el-checkbox v-model="rules">我同意<a @click="rulesDetailHandle">《医学检验服务协议》</a></el-checkbox>
                </p>
              </div>
            </div>

<!--        拼团-->
            <div v-if="groupInfo && !appointFlag">

              <div>
                <div class="not-select">
                  <div class="countDown">
                    <div>可参与拼团：</div>
                    <div style="color:#00c5b0;cursor: pointer" @click="allGroup = true">查看全部></div>
                  </div>
                  <div style="border-bottom:1px solid #ddd;padding-bottom: 8px">
                    <div v-for="item in newPt.slice(0, 2)" class="countDown-item">
                      <div>
                        <div style="display:flex;align-items: center;color:#101010">
                          <el-image src="static/c-icon.png" style="width: 18px;height:18px;margin-right: 8px"></el-image>
                          <span>还差{{item.groupMin - item.currentCount}}人成团&nbsp;&nbsp;&nbsp;剩余&nbsp;</span>
                          <Countdown :remainTime="timeDiff(item.endTime)" @countDowmEnd="$set(item, 'disabled', true)"></Countdown>
                        </div>
                      </div>
                      <span class="countDown-btn" :class="{'disabled-btn': user.isChannel && user.isChannel != 0 || item.groupMin === item.currentCount || timeDiff(item.endTime) < 0 || item.disabled}" @click="toPay(null, {groupId: item.id, endTime: item.endTime})">立即拼单</span>
                    </div>
                    <div class="flex-center-center" style="min-height: 55px" v-if="newPt.length === 0">暂无拼团,快去发起拼团吧~</div>
                  </div>

                  <div class="bug-tips" v-if="user.isChannel && user.isChannel != 0" style="text-align: right;padding:15px 0">非个人用户无法购买此商品</div>

                  <div class="groupBtn" style="display: flex;justify-content: flex-end;padding-top:10px" v-else>
                    <div style="display:flex;">
                      <el-popover
                        placement="bottom"
                        width="50"
                        :trigger="IsPC ? 'hover' : ''">
                        <div class="countDown-btn" style="padding:2px 28px;background-color:#d6f7f1;color:#00B09D;border-color:#00B09D;" @click="IsPC ? toPay(null) : selectNumber(null)" slot="reference">
                          <div>￥{{prodoctInfo.price | FormatCurrency}}</div>
                          <div>单独购买</div>
                        </div>
                        <div class="pop-content">
                          <el-input-number v-model="itemNum" :min="1" :max="9999" @change="handleChange" style="width: auto"></el-input-number>
                        </div>
                      </el-popover>
                      <div class="countDown-btn" style="padding:2px 28px;background:#00C5B0;color:#fff;border-color: #00C5B0;margin-left: 15px;" @click="toPay(null, {})">
                        <div>￥{{groupInfo.groupPrice | FormatCurrency}}</div>
                        <div>发起拼团</div>
                      </div>
                    </div>
                  </div>

                </div>

                <el-drawer
                  class="numberDrawer"
                  size="130"
                  :visible.sync="numberDrawer"
                  :show-close="false"
                  :with-header="false"
                  direction="btt">
                  <div class="numberSelect">
                    <span>购买数量</span>
                    <el-input-number v-model="itemNum" :min="1" :max="9999" @change="handleChange" style="width: auto"></el-input-number>
                  </div>
                  <div class="numberSubmit">
                    <a @click="toPay(null)">确定</a>
                  </div>
                </el-drawer>

                <el-dialog
                title=" "
                :visible.sync="allGroup"
                width="350px"
                top="28vh"
                :before-close="() => allGroup = false">
                <div class="not-select" slot="title" style="text-align: center;border-bottom:1px solid #bbb;padding-bottom: 18px">
                  可参与拼团
                </div>
                <div class="not-select" style="min-height:200px">
                  <div v-for="item in newPt.slice((spellGroup.page - 1) * spellGroup.size, spellGroup.page * spellGroup.size)" class="countDown-item" style="padding:6px 0">
                    <div>
                      <div style="display:flex;align-items: center;color:#101010">
                        <el-image src="static/c-icon.png" style="width: 18px;height:18px;margin-right: 8px"></el-image>
                        <span>还差{{item.groupMin - item.currentCount}}人成团&nbsp;&nbsp;&nbsp;剩余&nbsp;</span>
                        <Countdown :remainTime="timeDiff(item.endTime)" @countDowmEnd="$set(item, 'disabled', true)" v-if="ctd"></Countdown>
                      </div>
                    </div>
                    <span v-if="ctd" class="countDown-btn" :class="{'disabled-btn': user.isChannel && user.isChannel != 0 || item.groupMin === item.currentCount || timeDiff(item.endTime) < 0 || item.disabled}" @click="toPay(null, {groupId: item.id})">立即拼单</span>
                  </div>
                  <div class="flex-center-center" style="height:180px" v-if="newPt.length === 0">暂无拼团,快去发起拼团吧~</div>
                  <div style="margin-top: 30px;display: flex;justify-content: flex-end">
                    <el-pagination
                      small :hide-on-single-page="true"
                      :page-count="spellGroup.page"
                      :page-size="spellGroup.size"
                      @current-change="pageChange"
                      :total="newPt.length"
                      layout="prev, pager, next, total">
                    </el-pagination>
                  </div>
                </div>
              </el-dialog>
              </div>
            </div>

            <div v-else>
              <div class="Activity doThing" v-if="needAttr.length">
                <div class="myBtn">
                  <!-- 线上 -->
                  <!--                <a href="javascript:void(0)" @click="toAuth">开通购买权限申请</a>-->
                  <a @click="needPower(needAttr[0])">{{needAttr[0].specialAttributeName + '申请'}}</a>
                  <!--<a class="toDonate" :href="apiPath + '/service/questionnaire/contribution/index.html?source=web'" target="_blank" style="background:#E50015">捐赠通道</a>-->
                </div>
              </div>
              <div class="Activity doThing" v-else-if="!needAttr.length && originalProdoctInfo.purchasePermissions == 0 && $store.state.user.isChannel != 1">
                <div class="myBtn">
                  <a href="https://xcx.liferiverdx.com/service/enterprise/auth/index.html#/" target="_blank">企业资质申请</a>
                  <!--<a class="toDonate" :href="apiPath + '/service/questionnaire/contribution/index.html?source=web'" target="_blank" style="background:#E50015">捐赠通道</a>-->
                </div>
              </div>

              <!--              已通过申请-->
              <div class="doThing" v-else>
                <div class="aboutNum">
                  数量
                  <el-input-number v-if="appointFlag" v-model="itemNum" controls-position="right" :min="1" :disabled="true"></el-input-number>
                  <el-input-number v-else v-model="itemNum" controls-position="right" @change="handleChange"
                                   :min="1" :max="9999" style="width: 80px"></el-input-number>
                </div>
                <div class="myBtn">
                  <span v-show="!hasPcKey" v-if="!appointFlag">
                    <el-button round @click="addCart(prodoctInfo.orderFlag)" :disabled="prodoctInfo.status == 2 || prodoctInfo.status == 0">加入购物车</el-button>
                  </span>
                  <span class="bug-tips" v-if="appointFlag && user.isChannel && user.isChannel != 0">非个人用户无法购买此商品</span>
                  <el-button v-else round type="primary" @click="prodoctInfo.scanMark === 'xinGuanSelf' ? xgPay(prodoctInfo.orderFlag) : toPay(prodoctInfo.orderFlag, appointFlag && groupGoods ? {} : null)" :disabled="prodoctInfo.status == 2 || prodoctInfo.status == 0">{{appointFlag?(groupGoods? '参加拼团': '立即预约') :'立即购买'}}</el-button>
                  <!--<a class="toDonate PC_donate" :href="apiPath + '/service/questionnaire/contribution/index.html?source=web'">捐赠通道</a>-->
                  <!--<a class="toDonate mobile_donate" :href="apiPath + '/service/questionnaire/contribution/index.html?source=web'">捐</a>-->
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="product_params" v-if="prodoctInfo.samplerName || prodoctInfo.itemFactoryExtraEntity || prodoctInfo.itemList">
        <!-- 项目 套餐展示采样器信息 -->
        <template v-if="prodoctInfo.samplerName">
          <p class="product_params_title">采样器信息</p>
          <table>
            <tr>
              <td><div class="headline">采样器名称：</div><div class="content">{{prodoctInfo.samplerName}}</div></td>
              <td><div class="headline">标本类型：</div><div class="content">{{prodoctInfo.samplerTypeName}}</div></td>
              <td><div class="headline">采样器数量：</div><div class="content">{{prodoctInfo.num}}</div></td>
            </tr>
            <tr>
              <td><div class="headline">计量单位：</div><div class="content">{{prodoctInfo.unitValue + prodoctInfo.unit}}</div></td>
              <td><div class="headline">存储条件：</div><div class="content">{{prodoctInfo.storing}}</div></td>
              <td><div class="headline">检测方法：</div><div class="content">{{prodoctInfo.testMethod}}</div></td>
            </tr>
            <tr>
              <td><div class="headline">临床意义：</div><div class="content">{{prodoctInfo.clinicalSignificance}}</div></td>
              <td><div class="headline">备注：</div><div class="content">{{prodoctInfo.remark ? prodoctInfo.remark:"无"}}</div></td>
            </tr>
          </table>
        </template>
        <template v-if="prodoctInfo.itemList" v-for="item in prodoctInfo.itemList">
          <p class="product_params_title">采样器信息</p>
          <table>
            <tr>
              <td><div class="headline">采样器名称：</div><div class="content">{{item.samplerName}}</div></td>
              <td><div class="headline">标本类型：</div><div class="content">{{item.samplerTypeName}}</div></td>
              <td><div class="headline">采样器数量：</div><div class="content">{{item.num}}</div></td>
            </tr>
            <tr>
              <td><div class="headline">计量单位：</div><div class="content">{{item.unitValue + item.unit}}</div></td>
              <td><div class="headline">存储条件：</div><div class="content">{{item.storing}}</div></td>
              <td><div class="headline">检测方法：</div><div class="content">{{item.testMethod}}</div></td>
            </tr>
            <tr>
              <td><div class="headline">临床意义：</div><div class="content">{{item.clinicalSignificance}}</div></td>
              <td><div class="headline">备注：</div><div class="content">{{item.remark ? item.remark:"无"}}</div></td>
            </tr>
          </table>
        </template>
        <template v-if="prodoctInfo.itemFactoryExtraEntity">
          <p class="product_params_title">商品参数</p>
          <table>
            <tr>
              <td><div class="headline">注册证编号：</div><div class="content">{{prodoctInfo.itemFactoryExtraEntity.registCode}}</div></td>
              <td><div class="headline">医疗器械68分类编号：</div><div class="content">{{prodoctInfo.itemFactoryExtraEntity.opCategoryCode}}</div></td>
              <td><div class="headline">产品有效期：</div><div class="content">{{prodoctInfo.itemFactoryExtraEntity.expiryDate}}</div></td>
            </tr>
            <tr>
              <td><div class="headline">货号：</div><div class="content">{{prodoctInfo.itemFactoryExtraEntity.articleNumber}}</div></td>
              <td><div class="headline">医疗器械68分类名称：</div><div class="content">{{prodoctInfo.itemFactoryExtraEntity.opCategoryName}}</div></td>
            </tr>
            <tr>
              <td><div class="headline">规格：</div><div class="content"><span v-for="item in prodoctInfo.itemSpecList">{{item.spec}}；</span></div></td>
              <td><div class="headline">医疗器械68分类类别：</div><div class="content">{{prodoctInfo.itemFactoryExtraEntity.opCategoryType}}</div></td>
            </tr>
            <tr>
              <!--<td>适用仪器：{{prodoctInfo.itemFactoryExtraEntity.appliedInstrument}}</td>-->
              <td><div class="headline">是否CFDA产品：</div><div class="content">{{prodoctInfo.itemFactoryExtraEntity.cfdaFlag?'是':'否'}}</div></td>
            </tr>
          </table>
        </template>
      </div>
      <p class="desc">详情</p>
      <div class="detail">
        <div v-html="prodoctInfo.desc"></div>
        <br/>
        <div v-html="prodoctInfo.detail" class="detail_info"></div>
      </div>
    </div>

    <!--<nav-footer></nav-footer>-->

    <!--协议信息弹框-->
    <rules-detail v-if="rulesDetailVisible" ref="rulesDetail"></rules-detail>
    <!-- 优惠券弹框 -->
    <coupons-detail v-if="couponsDetailVisible" ref="couponsDetail"></coupons-detail>

    <!--注意事项-->
    <el-dialog :visible.sync="attentionVisible" width="450px" title="注意事项" class="attention">
      <div class="attention_content">
        <p>1、新冠自采样检测目前支持收样范围：<span class="attention_key">上海市徐汇区、黄浦区，</span>请确认您处在上述区域范围内。</p>
        <p>2、新冠自采样检测目前支持收样时间为<span class="attention_key">上午8：00~12：00，下午13：00~16：00。</span></p>
        <p>3、新冠标本保存条件为：室温放置不超过4小时、冷藏（4℃）放置不超过24小时，请确保您的样本从采样完成到上门收样的时间不超过上述时间范围，因自身原因导致样本失效而影响检测结果，我司概不负责。</p>
        <p>4、收到采样盒后请观看指导视频，并根据视频步骤进行采样和录制采样视频，并在<span class="attention_key">《自身采样承诺书》</span>上签字。</p>
        <p>5、上门收样时，请将样本送至园区/建筑门口等通风环境处。</p>
        <p>6、若您无法满足上述要求，我司有权拒绝接收样本，费用不予退还</p>
      </div>
      <div class="attention_btn">
        <p @click="toPay(null)">同意并继续下一步</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import NavHeader from '@/components/Header'
  import NavBread from '@/components/Bread'
  import NavFooter from '@/components/Footer'
  import '@/assets/css/index.css'
  import { getCookie, removeHTMLTag, delCookie, discountCoupon, IsPC } from '../../util/util';
  import RulesDetail from '../../components/rules-detail'
  import CouponsDetail from '../../components/coupons-detail'
  import Countdown from './countdown'
  import axios from 'axios'
  import { pagePath } from '../../util/global'

  export default {
    name: "detection",
    data() {
      return {
        apiPath: pagePath,
        groupInfo: null,
        groupList: [],
        allGroup: false,
        ctd: true,
        spellGroup: {
          page: 1,
          size: 5
        },
        rulesDetailVisible: false,
        id: this.$route.query.id,
        remark: this.$route.query.remark,
        needAttr: [],
        items: [],
        category: {},
        prodoctInfo: {},
        originalProdoctInfo: {},
        exInfoList: [],
        checkExInfoList: [],
        itemNum: 1,
        p_showSearch: true,
        loading: true,
        p_loginModalFlag: false,
        p_showNavbar: true,
        p_showCart: true,
        itemCartNumber: 0,
        itemSpecList: [],
        tagType: "info",
        checkedSpecId: "",
        nodeIds: [],
        specNumber: 1,
        checkedSpecIndex: 0,
        bannerHeight: 0,
        rules: false,
        hasPcKey: getCookie("pc") ? true : false,  // 推广扫码标识
        //是否合作标识
        isCooperationFlag: false,
        applyAuth: false,
        enterAuth: false,
        providerId: this.$store.state.providerId || localStorage.getItem("providerId") || '',
        //预约
        appointFlag: false,
        apptRoute: '',
        groupGoods: '',
        groupMin: '',
        apptDeadline: '',
        // 优惠券
        couponsDetailVisible: false,
        itemcouponsList: [],
        // 拼团-单独购买数量
        numberDrawer: false,
        attentionVisible: false
      }
    },
    components: {
      NavHeader,
      NavBread,
      NavFooter,
      RulesDetail,
      CouponsDetail,
      Countdown
    },
    computed: {
      user() {
        return this.$store.state.user;
      },
      discountCoupon () {
        return function (number1, number2) {
          return discountCoupon(number1, number2)
        }
      },
      timeDiff () {
        return function (time) {
          if (time) {
            try {
              return +(new Date(time.replace(/-/g, "/"))) - +new Date()
            } catch (e) {
              return 0
            }
          } else {
            return 0
          }
        }
      },
      newPt () {
        try {
          return this.groupList.filter(e => this.timeDiff(e.endTime) > 0 || e.groupMin > e.currentCount)
        } catch (e) {
          return []
        }
      },
      IsPC (){
        return IsPC()
      }
    },
    mounted () {
      this.checkAttr()
      this.getDetectionInfo()
      this.imgLoad()
      window.addEventListener('resize', () => {
        this.bannerHeight = this.$refs.bannerHeight[0].height
        this.imgLoad()
      }, false)
      this.getExInfoListInfo()
      if (getCookie("pc")) {
        setTimeout(() => {
          delCookie("pc")
          this.$refs.navHeader.logout()
          this.$message({
            showClose: true,
            message: '登录信息失效,请重新登录',
            type: 'error'
          });
        }, 43200000)
      }
      if (getCookie("_token")) {
        console.log('登录获取优惠券')
        this.getItemcouponsList(this.id)
      } else {
        console.log('未登录获取优惠券')
        this.getItemcouponsList_unlogin(this.id)
      }
    },
    beforeDestroy() {
      clearTimeout();
    },
    methods: {
      needPower (e) {
        if (!getCookie("_token")) {
          this.$message({
            showClose: true,
            message: '登录信息失效,请重新登录',
            type: 'error'
          });
          this.p_showLoginModal()
        } else {
          if (this.checkExInfoList.length == this.exInfoList.length && this.rules) {
            let {specialValue} = e
            if (specialValue.includes('http')) {
              window.open(needAttr[0].specialValue)
            } else {
              this.$router.push({
                name: specialValue
              })
            }
          } else {
            this.$message({
              showClose: true,
              message: '请勾选注意事项',
              type: 'error'
            });
            window.scrollTo(0, 0)
          }
        }
      },
      imgLoad() {
        this.$nextTick(() => {
          this.bannerHeight = this.$refs.bannerHeight[0].height
        })
      },

      checkAttr () {
        axios.get(`jys/item/compare/attr/${this.id}`, {
          headers: {
            "Content-Type": "application/json",
            'token': getCookie("_token") ? getCookie("_token") : "",
            "pcKey": getCookie("pc")
          }
        }).then(({data}) => {
          if (data.code === 0) {
            this.needAttr = data.needAttr
          }
        })
      },

      p_showLoginModal() {
        this.p_loginModalFlag = true
      },
      p_closeLoginModal() {
        this.p_loginModalFlag = false
      },

      pageChange (page) {
        this.spellGroup.page = page
        this.ctd = false
        setTimeout(() => {this.ctd = true}, 1)
      },

      //选择规格
      checkItemSpec() {
        console.log(this.checkedSpecId)
        for (var i = 0; i < this.itemSpecList.length; i++) {
          if (this.checkedSpecId == this.itemSpecList[i].id) {
            this.specNumber = this.itemSpecList[i].specNumber;
            this.checkedSpecIndex = i
          }
        }
      },

      apply (path, key) {
        if (getCookie("_token")) {
          path ? this.$router.push(path) : window.location.href = this.apiPath + '/service/apply/index' + key + '.html'
        } else {
          this.$message({
            showClose: true,
            message: '登录信息失效,请重新登录',
            type: 'error'
          });
          this.p_showLoginModal()
        }
      },

      toAuth () {
        if (getCookie("_token")) {
          window.location.href = this.apiPath + '/service/enterprise/auth/index.html#/'
        } else {
          this.$message({
            showClose: true,
            message: '登录信息失效,请重新登录',
            type: 'error'
          });
          this.p_showLoginModal()
        }
      },

      toApplyEnter() {
        if (getCookie("_token")) {
          this.$router.push({path: "/NovelCoronavirusEnter"})
        } else {
          this.$message({
            showClose: true,
            message: '登录信息失效,请重新登录',
            type: 'error'
          });
          this.p_showLoginModal()
        }
      },

      // 呼吸道病原体检测
      toBreath() {
        this.$router.push({path: "/NovelCoronavirusSample"})
      },

//    	id列表获取项目详情
      getDetectionInfo() {
        axios.get("/jys/item/" + this.id, {
          headers: {
            "Content-Type": "application/json",
            'token': getCookie("_token") ? getCookie("_token") : "",
            "pcKey": getCookie("pc")
          }
        }).then((res) => {
          console.log('res', res)
          var item = res.data.item
          var imgs = JSON.parse(item.imgs);
          this.items = imgs;
          this.category = res.data.category;
          this.prodoctInfo = item;
          let groupInfo = res.data.groupInfo
          if (groupInfo) {
            if (item.apptGoods !== 1 && (+new Date() > +new Date(groupInfo.endTime.replace(/-/g,'/')) || +new Date() < +new Date(groupInfo.beginTime.replace(/-/g,'/'))) && !!(groupInfo.beginTime && groupInfo.endTime)) {
              // 不属于预约拼团 且 拼团未开始 或 已结束
            } else {
              this.groupInfo = res.data.groupInfo || null;
              this.groupList = res.data.groupList
            }
          }
          if (res.data.item.apptGoods === 1) {
            this.appointFlag = true
            this.apptRoute = res.data.apptRoute
            this.groupGoods = res.data.item.groupGoods
            this.groupMin = res.data.groupInfo ? res.data.groupInfo.groupMin : 0
            this.apptDeadline = res.data.groupInfo ? res.data.groupInfo.apptDeadline : ''
          }

          try {
            let mobile = this.$store.state.user.mobile
            if (res.data.category.name === '疫情质控品') {
              console.log('疫情质控品')
              axios.get(`/jys/questionnaire/qualityControlProducts/mobile?mobile=${mobile}`, {
                headers: {
                  "Content-Type": "application/json",
                  'token': getCookie("_token") ? getCookie("_token") : "",
                  "pcKey": getCookie("pc")
                }
              }).then(({data}) => {
                this.applyAuth = data.jysQuestionnaire && data.jysQuestionnaire.status === '1'
              })
            } else if (res.data.category.name === '疫情产品' || res.data.category.name === '海外疫情产品') {
              console.log('疫情产品')
              axios.get(`/jys/channel/respiratory/ract/power`, {
                headers: {
                  "Content-Type": "application/json",
                  'token': getCookie("_token") ? getCookie("_token") : "",
                  "pcKey": getCookie("pc")
                }
              }).then(({data}) => {
                this.applyAuth = !!data.channel && data.channel.respiratoryRactPower != '0'
                this.enterAuth = data.channel && data.channel.foreignPurchasePermission == 1
              })
            }
          } catch (err) {}
          this.originalProdoctInfo = res.data.item;
          this.loading = false
          this.itemSpecList = res.data.item.itemSpecList;
          this.checkedSpecId = this.itemSpecList[this.checkedSpecIndex].id
          this.isCooperation(res.data.item.id)
        })
      },

      isCooperation(id) {
        axios.get("/jys/item/channelPartnerCooperation", {
          params:{
            itemId: id
          }
        }).then((res) => {
          if (res.data.code === -1) {
            this.isCooperationFlag = false
          } else {
            this.isCooperationFlag = true
          }
        })
      },

//		 获取额外信息
      getExInfoListInfo() {
//          axios.get("/jys/itemExInfo/"+this.id,{params:{remark:this.remark}}).then((res)=>{
        axios.get("/jys/itemExInfo/" + this.id, {params: {remark: 1}}).then((res) => {
          this.exInfoList = res.data.exInfoList
        })
      },

//       跳转到店铺
      toCompany(id) {
        this.$router.push({path: "/company/index", query: {id: id}})
      },
      handleChange(value) {
        console.log(value);
        this.itemNum = value
      },

      // 购物车查询这个商品的数量并加以判断
      getItemCartNumber() {
        let itemCartNumber = this.itemSpecList[this.checkedSpecIndex].number
        let itemId = this.prodoctInfo.id
        let number = this.itemNum
        //判断不能超过9999
        if (itemCartNumber >= 9999 || (number + itemCartNumber) > 9999) {
          this.$message({
            showClose: true,
            message: '该商品数量最多只能添加9999',
            type: 'error'
          });
        } else {
          axios.post("/jys/cart?shopId=" + this.providerId, {
            itemId,
            number,
            itemSpecId: this.checkedSpecId,
            checked: false,
            itemExInfoIds: this.exInfoList.map(e => e.id)
            // noteIds,
          }, {
            headers: {
              "Content-Type": "application/json",
              'token': getCookie("_token"),
              "pcKey": getCookie("pc"),
            }
          }).then((response) => {
            let res = response.data
            if (res.code == 0) {
              this.$message({
                showClose: true,
                message: '成功加入购物车',
                type: 'success'
              });
              this.getDetectionInfo()
              this.$refs.navHeader.getCartCount()
            }
          })
        }
      },

      //加入购物车
      addCart(orderFlag) {
        if (getCookie("_token")) {
          if (orderFlag === 2) {
            this.$message({
              showClose: true,
              message: '当前用户无法购买',
              type: 'error'
            });
          } else {
            if (this.isCooperationFlag) {
              // 耗材不显示检验服务协议
              if (this.prodoctInfo.type === 2) {
                this.rules = true
              }
              if (this.checkExInfoList.length == this.exInfoList.length && this.rules) {
                this.getItemCartNumber()
              } else {
                this.$message({
                  showClose: true,
                  message: '请勾选注意事项',
                  type: 'error'
                });
              }
            } else {
              this.$message({
                showClose: true,
                message: '还未与检验所建立关系无法下单',
                type: 'error'
              })
            }
          }
        }else{
          this.$message({
            showClose: true,
            message: '登录信息失效,请重新登录',
            type: 'error'
          });
          this.p_showLoginModal()
        }
      },
      NoteIds(val) {
        // console.log(val)
        // console.log(this.checkExInfoList)
        // console.log(this.nodeIds)
      },

      //购买
      toPay(orderFlag, groupInfo) {
        if (getCookie("_token")) {
          if (orderFlag === 2) {
            this.$message({
              showClose: true,
              message: '当前用户无法购买',
              type: 'error'
            });
          } else {
            if (this.isCooperationFlag) {
              let checkedList = []
              let itemNum = !!this.groupInfo && !!groupInfo ? 1 : this.itemNum

              let itemPrice = !!this.groupInfo && !!groupInfo ? this.groupInfo.groupPrice : this.prodoctInfo.price
              this.prodoctInfo.number = itemNum
              this.prodoctInfo.checked = true
              this.prodoctInfo.specPrice = itemPrice * this.specNumber

              //选中的规格组成的数组
              let checkedSpec = this.itemSpecList[this.checkedSpecIndex]
              let checkedSpecList = []
              checkedSpecList.push(checkedSpec)

              this.prodoctInfo.itemSpecList = checkedSpecList

              checkedList.push(this.prodoctInfo)

              // 耗材不显示检验服务协议
              if (this.prodoctInfo.type === 2) {
                this.rules = true
              }

              if (this.checkExInfoList.length == this.exInfoList.length && this.rules) {
                if (this.itemNum > 0) {
                  //下单的商品信息
                  this.$store.commit("updateCheckedGoodsList", checkedList);
                  this.$router.push({
                    path: this.appointFlag ? this.apptRoute : 'Address',
                    query: {
                      // 'checkedList': JSON.stringify(checkedList),
                      'totalMoney': itemNum * this.prodoctInfo.specPrice,
                      'fromCart': false,
                      'checkedSpecId': this.checkedSpecId,
                      'type':this.prodoctInfo.type,
                      'itemId': this.id,
                      'groupMin': this.groupMin,
                      'groupGoods': this.groupGoods,
                      'apptDeadline': this.apptDeadline,
                      'groupInfo': groupInfo ? JSON.stringify({
                        ...groupInfo,
                        ...this.groupInfo && groupInfo ? { price: this.groupInfo.groupPrice } : {}
                      }) : null
                    }
                  })
                } else {
                  this.$message({
                    showClose: true,
                    message: '数量不能为空',
                    type: 'error'
                  })
                }
              } else {
                this.$message({
                  showClose: true,
                  message: '请勾选注意事项',
                  type: 'error'
                })
              }
            } else {
              this.$message({
                showClose: true,
                message: '还未与检验所建立关系无法下单',
                type: 'error'
              });
            }
          }
        }else{
          this.$message({
            showClose: true,
            message: '登录信息失效,请重新登录',
            type: 'error'
          });
          this.p_showLoginModal()
        }
      },

      // 拼团-单独购买选择数量
      selectNumber (orderFlag) {
        if (getCookie("_token")) {
          if (orderFlag === 2) {
            this.$message({
              showClose: true,
              message: '当前用户无法购买',
              type: 'error'
            });
          } else {
            if (this.isCooperationFlag) {
              // 耗材不显示检验服务协议
              if (this.prodoctInfo.type === 2) {
                this.rules = true
              }
              if (this.checkExInfoList.length == this.exInfoList.length && this.rules) {
                this.numberDrawer = true
              } else {
                this.$message({
                  showClose: true,
                  message: '请勾选注意事项',
                  type: 'error'
                })
              }
            } else {
              this.$message({
                showClose: true,
                message: '还未与检验所建立关系无法下单',
                type: 'error'
              });
            }
          }
        }else{
          this.$message({
            showClose: true,
            message: '登录信息失效,请重新登录',
            type: 'error'
          });
          this.p_showLoginModal()
        }
      },

      rulesDetailHandle () {
        this.rulesDetailVisible = true
        this.$nextTick(() => {
          this.$refs.rulesDetail.init()
        })
      },
      couponsDetailHandle (itemId) {
        this.couponsDetailVisible = true
        this.$nextTick(() => {
          this.$refs.couponsDetail.init(itemId)
        })
      },
      //获取项目可用优惠券(未登录)
      getItemcouponsList_unlogin(itemId) {
        var itemType = itemId.toString().indexOf('a') == -1 ? 0 : 1
        var id = itemId.toString().split('a').join("")
        axios.get('/ai/coupon/item/nologin', {
          params: {
            platform: 'ZYJY',
            itemId,
            itemType
          }
        }).then((res) => {
          console.log('res', res)
          if (res.data.code == 0) {
            this.itemcouponsList = res.data.list
            var itemcouponsList = res.data.list
            var curDate = new Date().getTime()
            for (var i = 0; i < itemcouponsList.length; i++) {
              if (itemcouponsList[i].rangeEndTime) {
                itemcouponsList[i].rangeEndTime = itemcouponsList[i].rangeEndTime.replace(/-/g, '/')
                itemcouponsList[i].rangeBeginTime = itemcouponsList[i].rangeBeginTime.replace(/-/g, '/')
                var endDate = Date.parse(new Date(itemcouponsList[i].rangeEndTime))
                var beginDate = Date.parse(new Date(itemcouponsList[i].rangeBeginTime))
                if ((beginDate - curDate) > 0) {
                  itemcouponsList[i].isShowBeginDate = true
                } else {
                  itemcouponsList[i].isShowBeginDate = false
                }
              }
            }
          }
        })
      },
      //获取项目可用优惠券(登录)
      getItemcouponsList(itemId) {
        console.log('itemId', itemId)
        var itemType = itemId.toString().indexOf('a') == -1 ? 0 : 1
        var id = itemId.toString().split('a').join("")
        axios.get('/ai/coupon/item', {
          params: {
            platform: 'ZYJY',
            itemId,
            itemType
          }
        }).then((res) => {
          console.log('获取项目可用优惠券 res', res)
          if (res.data.code == 0) {
            this.itemcouponsList = res.data.list
            var itemcouponsList = res.data.list
            var curDate = new Date().getTime()
            console.log('itemcouponsList.length', itemcouponsList.length)
            for (var i = 0; i < itemcouponsList.length; i++) {
              if (itemcouponsList[i].rangeEndTime) {
                itemcouponsList[i].rangeEndTime = itemcouponsList[i].rangeEndTime.replace(/-/g, '/')
                itemcouponsList[i].rangeBeginTime = itemcouponsList[i].rangeBeginTime.replace(/-/g, '/')
                var endDate = Date.parse(new Date(itemcouponsList[i].rangeEndTime))
                var beginDate = Date.parse(new Date(itemcouponsList[i].rangeBeginTime))
                if ((beginDate - curDate) > 0) {
                  itemcouponsList[i].isShowBeginDate = true
                } else {
                  itemcouponsList[i].isShowBeginDate = false
                }
              }
            }
          }
        })
      },
      xgPay(orderFlag) {
        if (getCookie("_token")) {
          if (orderFlag === 2) {
            this.$message({
              showClose: true,
              message: '当前用户无法购买',
              type: 'error'
            });
          } else {
            if (this.isCooperationFlag) {
              // 耗材不显示检验服务协议
              if (this.prodoctInfo.type === 2) {
                this.rules = true
              }
              if (this.checkExInfoList.length == this.exInfoList.length && this.rules) {
                this.attentionVisible = true
              } else {
                this.$message({
                  showClose: true,
                  message: '请勾选注意事项',
                  type: 'error'
                });
              }
            } else {
              this.$message({
                showClose: true,
                message: '还未与检验所建立关系无法下单',
                type: 'error'
              })
            }
          }
        }else{
          this.$message({
            showClose: true,
            message: '登录信息失效,请重新登录',
            type: 'error'
          });
          this.p_showLoginModal()
        }
      }
    }
  }
</script>

<style scoped>
  .banner {
    width: 100%;
    background-color: #fff;
    margin: 0 auto;
    /*margin-top: 20px;*/
  }

  .el-row {
    margin-bottom: 0;
    padding: 20px 0;
  }

  .left, .right {
    padding: 20px;
  }

  .myCaro {
    text-align: center;
  }
  .container {
    width: 70%;
  }
  .myCaro .detPic {
    max-width: 100%;
    max-height: 400px;
  }

  .both {
    clear: both;
  }

  .decMain {
    width: 100%;
    /*margin-top: 50px;*/
    border-bottom: 1px solid #ddd;
    padding-bottom: 10px;
  }

  .detail {
    width: 85%;
    margin: 35px auto;
    background-color: #fff;
  }

  .detail_info {
    width: 100%;
  }

  .detail_info >>> img {
    max-width: 100%;
  }

  .sub {
    float: right;
    margin-top: 200px;
  }

  .info {
    display: block;
    margin-top: 10px;
  }

  .el-checkbox + .el-checkbox {
    margin-left: 0;
  }

  .check {
    margin-top: 10px;
  }

  .check .check-title {
    height: 40px;
    line-height: 40px;
    font-size: 14px;
  }

  .check-attention{
    font-weight: bolder;
    color: #FE2042;
    font-size: 14px;
    margin-left: -7px;
  }

  .itemname {
    font-size: 20px;
    margin: 10px 0;
    font-weight: bold;
    display: inline-block;
  }

  .itemprice {
    color: #FE2042;
    font-size: 26px;
    /*float: right;*/
    display: block;
  }

  .itemprice span {
    color: #999999;
    font-size: 14px;
    padding-left: 10px;
  }

  .providerName {
    font-size: 16px;
    cursor: pointer;
  }

  .aboutNum {
    margin-top: 10px;
    margin-bottom: 10px;
    display: inline-block;
    font-size: 14px;
  }

  .myBtn {
    margin-top: 10px;
    margin-bottom: 10px;
    display: inline-block;
    float: right;
  }

  .Activity .myBtn a {
    display: inline-block;
    background: #00C5B0;
    color: #fff;
    height: 32px;
    line-height: 32px;
    border-radius: 20px;
    height: auto;
    text-align: center;
    padding: 0 20px;
    margin-left: 10px;
  }

  .toDonate.PC_donate {
    display: inline-block;
    background:#E50015;
    color:#fff;
    padding:0 12px;
    margin-left:5px;
    border-radius:30px;
    font-size:12px;
    height:32px;
    line-height:32px;
    margin-top:10px;
  }

  .toDonate.mobile_donate {
    display: inline-block;
    background:#E50015;
    color:#fff;
    padding:0 12px;
    border-radius:30px;
    font-size:12px;
    height:32px;
    line-height:32px;
    margin-top:10px;
    /*margin-left:5px;*/
  }

  .buyBtn {
    background: #00C5B0;
    color: #fff;
  }

  .desc {
    width: 100%;
    float: left;
    padding: 20px;
    background: #f1f1f1;
    margin-bottom: 10px;
  }

  .seeSome {
    margin-left: 20px;
    font-size: 14px;
    cursor: pointer;
  }

  .doThing {
    width: 100%;
    height: 50px;
    line-height: 50px;
  }

  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #00C5B0;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #00C5B0;
    border-color: #00C5B0;
  }

  /*.el-carousel__container{height: 626px;}*/
  /*.detPic{width: 100%;height: 625.8px;}*/

  .cart-item-pic img {
    width: 100%;
    height: 100%;
  }


  .product_params {
    width: 100%;
    float: left;
    padding: 10px 20px 20px 20px;
    margin-bottom: 25px;
    background-color: #f1f1f1;
  }

  .product_params_title {
    margin: 10px 0;
    font-weight: bolder;
  }

  .product_params table {
    width: 100%;
  }

  .product_params td {
    width: 33%;
    padding: 5px 0;
    float: left;
    word-wrap: break-word;
    word-break: break-all;
  }

  .headline{
    float: left;
  }
  .content{
    max-width: 75%;
    float: left;
    overflow:hidden;
  }

  /deep/ .el-checkbox{
    width: 100%;
    white-space: normal;
  }
  /deep/ .el-checkbox__input{
    width: 20px;
    vertical-align: top;
    padding-top: 3px;
  }
  /deep/ .el-checkbox__label{
    width: 90%;
  }

  /deep/ .el-checkbox__inner{
    width: 15px;
    height: 15px;
  }

  .agreement{
    width: 100%;
    font-size: 14px;
    margin-top: 10px;
  }
  .agreement a{
    color: #006BC2;
  }
  .aboutNum /deep/ .el-input,
  .aboutNum .is-disabled{
    width: 80px;
  }
  /deep/ .el-input {
    width: 97px;
  }
  /deep/ .el-input-number--small {
    width: 97px;
  }
  /deep/ .el-checkbox__label {
    padding-left: 0;
  }
  .detail table{
    width: 100%;
  }

  .mobile_donate {
    display: none !important;
  }

  .bug-tips{
    font-size: 12px;
  }

  .numberDrawer .numberSelect {
    width: 80%;
    margin:  0 auto;
    padding: 20px 0;
  }

  .numberDrawer .numberSelect span {
    display: inline-block;
    width: 47%;
    font-size: 14px;
  }

  .numberDrawer .numberSelect >>> .el-input-number{
    width: 50% !important;
  }

  .numberDrawer .numberSelect >>> .el-input{
    width: 100%;
  }

  .numberDrawer .numberSubmit a {
    display: block;
    width: 80%;
    margin:  0 auto 20px auto;
    line-height: 35px;
    font-size: 14px;
    text-align: center;
    color: #fff;
    background-color: #00C8B2;
    border-radius: 20px;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .coupons .coupons_wrap {
      width: 300px;
      margin-right: 0;
    }

    .PC_donate {
      display: none !important;
    }

    .mobile_donate {
      display: inline-block !important;
    }

    .el-row {
      display: flex;
      flex-flow: column;
      padding-bottom: 0;
    }

    .el-checkbox {
      white-space: normal;
    }

    .el-checkbox .el-checkbox__input {
      width: 20px;
      float: left;
      display: initial;
    }

    .el-checkbox .el-checkbox__label {
      width: 90%;
    }

    .product_params td {
      width: 100%;
    }

    /deep/ .detail_info img {
      width: 100%;
    }

    .el-col-12 {
      width: 100%;
    }
    .container {
      width: 100%;
    }
    .right {
      padding:5px  20px 20px;
    }
    .checktitle{
      border-bottom: 1px solid #ddd;
      padding-bottom: 15px;
    }
    .doThing{
      position: fixed;
      left: 0;
      bottom: 0;
      padding: 0 10px;
      height: 68px;
      right: 0;
      box-sizing: inherit;
      background: #fff;
      z-index: 999;
    }
    .detail{
      padding-bottom: 80px;
    }
    .groupBtn{
      justify-content: center !important;
      position: fixed;
      left: 0;
      bottom: 0;
      padding: 15px 0 !important;
      right: 0;
      box-sizing: inherit;
      background: #fff;
      z-index: 999;
    }
  }
</style>

<style scoped>
/* PC */
/* loadmore */
.weui-loadmore {
  width: 65%;
  margin: 3.5em auto;
  line-height: 1.6em;
  font-size: 14px;
  text-align: center;
}

.weui-loadmore__tips {
  display: inline-block;
  vertical-align: middle;
  color: #888;
}

/* main */
.coupons_wrap {
  display: flex;
  justify-content: space-between;
  overflow:hidden;
  width: 280px;
}

.regulation{
  width:100%;
  height:72px;
  line-height: 72px;
  background: #F5F5F5;
  text-align: right;
}
.regulation text{
  padding-right: 30px;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #576B95;
}

.list{
  width: 80%;
  display: flex;
  flex-wrap: wrap;
  /* margin-top: 40px; */
  margin: 0 auto;
}

.coupon_each {
  flex: 0 0 33%;
}

.list .coupon,
.list .coupon_grey{
  display: flex;
  width: 93%;
  /* width: 670px; */
  height: 155px;
  margin: 0 auto;
  background :#FFFFFF;
  margin-top: 40px;
  box-shadow:3px 3px 20px #d8d8d8;
}


.list .coupon .coupon_left,
.list .coupon_grey .coupon_left{
  width: 75%;
  height: 100%;
  /* overflow: hidden; */
  position: relative;

}
.list .coupon .coupon_left .tip,
.list .coupon_grey .coupon_left .tip{
  width: 45%;
  height: 100%;
  position: absolute;
}
.list .coupon .coupon_left .tip img,
.list .coupon_grey .coupon_left .tip img{
  width: 30%;
  height: 30%;
  position: absolute;
  top: 0;
  left: 0
}
.list .coupon .coupon_left .tip .txt,
.list .coupon_grey .coupon_left .tip .txt{
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #FFFFFF;
  position: absolute;
  top: 5px;
  left: 10px;
  /* z-index: 99 */
}
.list .coupon .coupon_left .price,
.list .coupon_grey .coupon_left .price{
  width: 50%;
  height: 100%;
  float: left;
  position: relative
}
.list .coupon .coupon_left .price .txt1,
.list .coupon_grey .coupon_left .price .txt1{
  font-family: PingFangSC-Semibold;
  font-size: 24px;
  color: #00C5B0;
  /* padding-left: 28px; */
  display: block;
  position: absolute;
  top: 36px;
  left: 48px;
}
.list .coupon .coupon_left .price .txt2,
.list .coupon_grey .coupon_left .price .txt2{
  font-family: DINCondensed-Bold;
  font-size: 64px;
  color: #00C5B0;
  letter-spacing: -1.87px;
  /* padding-left: 12px; */
  position:absolute;
  top: 0px;
  left: 80px;
}
.list .coupon .coupon_left .price1,
.list .coupon_grey .coupon_left .price1{
  width:198px;
  height: 100%;
  float: left;
  position: relative
}
.list .coupon .coupon_left .price1 .txt1,
.list .coupon_grey .coupon_left .price1 .txt1{
  font-family: PingFangSC-Semibold;
  font-size: 32px;
  color: #00C5B0;
  /* padding-left: 28px; */
  display: block;
  position: absolute;
  top: 36px;
  left: 28px;
}
.list .coupon .coupon_left .price1 .txt2,
.list .coupon_grey .coupon_left .price1 .txt2{
  font-family: DINCondensed-Bold;
  font-size: 96px;
  color: #00C5B0;
  letter-spacing: -1.87px;
  /* padding-left: 12px; */
  /* margin-left:60px; */
  position:absolute;
  top: 0px;
  left: 60px;
}
.list .coupon .coupon_left .price_discount,
.list .coupon_grey .coupon_left .price_discount{
  width:198px;
  height: 100%;
  float: left;

}
.list .coupon .coupon_left .price_discount .txt1,
.list .coupon_grey .coupon_left .price_discount .txt1{
  font-family: DINCondensed-Bold;
  font-size: 64px;
  color: #00C5B0;
  letter-spacing: -1.87px;
  padding-left: 48px;

}
.list .coupon .coupon_left .price_discount .txt2,
.list .coupon_grey .coupon_left .price_discount .txt2{
  font-family: PingFangSC-Semibold;
  font-size: 16px;
  color: #00C5B0;
  padding-left: 12px;
  font-weight: bold;
}
.list .coupon .coupon_left .detail,
.list .coupon_grey .coupon_left .detail{
  height:100%;
}

.list .coupon .coupon_left .detail .detail_title,
.list .coupon_grey .coupon_left .detail .detail_title{
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #353535;
  line-height:30px;
  margin:36px 0 5px 0;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.list .coupon .coupon_left .detail  .detail_desc text,
.list .coupon_grey .coupon_left .detail  .detail_desc text{
  display: block;
  font-family: PingFangSC-Regular;
  font-size: 20px;
  color: #888888;
  /* line-height: 22px; */
}

.list .coupon .coupon_right,
.list .coupon_grey .coupon_right{
    width: 25%;
    height: 100%;
    text-align: center;
    position: relative;
    border-left:4px dotted #ddd;
    cursor: pointer;
}
.list .coupon .coupon_right::before,
.list .coupon .coupon_right::after,
.list .coupon_grey .coupon_right::before,
.list .coupon_grey .coupon_right::after{
    content: '';
    width: 24px;
    height: 24px;
    position: absolute;
    left: -12px;
    background: #f5f5f5;
    border-radius:12px;
}
.list .coupon .coupon_right::before,
.list .coupon_grey .coupon_right::before{
    top:-12px;
    box-shadow: inset 0 -4px 6px #d8d8d8;
}
.list .coupon .coupon_right::after,
.list .coupon_grey .coupon_right::after{
    bottom:-12px;
    box-shadow: inset 0 4px 6px #d8d8d8;

}
.list .coupon .coupon_right .progress,
.list .coupon_grey .coupon_right .progress{
  width: 32px;
  height:90px;
  margin:0 auto;

}
.list .coupon .coupon_right .progress img,
.list .coupon_grey .coupon_right .progress img{
  width: 32px;
  height: 90px;
}
.list .coupon .coupon_right .percent,
.list .coupon_grey .coupon_right .percent{
  width:100%;
  font-family: PingFangSC-Medium;
  font-size: 12px;
  color: #00C5B0;
  text-align: center;
  line-height: 12px;
  margin-top: 12px;
}
.list .coupon .coupon_right .percent_grey,
.list .coupon_grey .coupon_right .percent_grey{
  width:100%;
  font-family: PingFangSC-Medium;
  font-size: 8px;
  color: #B2B2B2;
  text-align: center;
  line-height: 12px;
  margin-top: 12px;
}
.list .coupon .coupon_right .btn,
.list .coupon_grey .coupon_right .btn{
  width: 90%;
  height: 24px;
  line-height: 24px;
  margin:0 auto;
  margin-top: 5px;
  background: #FE2042;
  border-radius: 20px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #FFFFFF;
  border-color: #FE2042;
}
.list .coupon .coupon_right .btn_grey,
.list .coupon_grey .coupon_right .btn_grey{
  width: 90%;
  height: 26px;
  line-height: 26px;
  margin:0 auto;
  margin-top: 5px;
  background: #B2B2B2;
  border-radius: 20px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #FFFFFF;
}

/*已抢完的优惠券*/
.list .coupon_grey{
  background: #F5F5F5;
}

.list .coupon_grey .coupon_left .price .txt1,
.list .coupon_grey .coupon_left .price1 .txt1,
.list .coupon_grey .coupon_left .price_discount .txt1,
.list .coupon_grey .coupon_left .price .txt2,
.list .coupon_grey .coupon_left .price1 .txt2,
.list .coupon_grey .coupon_left .price_discount .txt2,
.list .coupon_grey .coupon_left .detail .detail_title,
.list .coupon_grey .coupon_left .detail  .detail_desc text,
.list .coupon_grey .coupon_right .percent{
  color: #B2B2B2;
}

.list .coupon_grey .coupon_right .btn{
  background: #E2E2E2;
  color: #B2B2B2;
}

.result-empty{
  width: 100%;
  height: 100%;
  padding-top: 300px;
}

.result-empty .icon{
  margin: 0 auto;
  display: block;
  width: 240px;
  height: 240px;
}

.result-empty .text{
  display: block;
  width: 100%;
  height: 40px;
  font-size: 28px;
  text-align: center;
  color: #999;
  padding-top:40px;
}

.index_icon{
  width:124px;
  height: 124px;
  position:fixed;
  right:15px;
  bottom:130px;
  z-index: 999;
}
.index_icon .icon_img{
  width:124px;
  height: 124px;
}
/* 底部按钮 */
.footer{
  width:100%;
  height:146px;
  position:fixed;
  z-index: 111;
  bottom:0px;
  background-img: linear-gradient(-180deg, rgba(255,255,255,0.00) 0%, #FFFFFF 13%);
}
.footer .footer_btn,.footer .footer_btn[disabled] {
  width:690px;
  height:96px;
  line-height: 96px;
  margin-left: 30px;
  margin-top:25px;
  background: #00C5B0;
  box-shadow: 0 2px 4px 0 rgba(0,197,176,0.30);
  border-radius: 3px;
  float: left;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #FFFFFF;
  text-align: center;
}

.coupons .coupon_img{
  width: 40px;
  height: 40px;
  position: absolute;
  top:20px;
  right: 10px;
}

.coupons {
  cursor: pointer;
}

.coupon_txt {
  /* margin-right: 10px; */
  color:red;
}

.coupon_item_wrap {
  display: flex;
  width: 160px;
  height: 20px;
}

.coupon_item {
  display: inline-block;
  width: 100px;
  margin-right: 6px;
  color:red;
  background-color: #FFF4F4;
  text-align: center;
}

.countDown {
  display: flex;justify-content: space-between;padding:8px 0;color:#7d7d7d;font-size: 13px;
}

.countDown-item {
  display: flex;justify-content: space-between;align-items: center;padding:2px 0;font-size: 12px;
}

.countDown-btn {
  border:1px solid #bbb;color:#101010;cursor: pointer;
  padding:3px 12px;border-radius: 25px;font-size: 12px;
}

.countDown-btn > div {padding:1.8px 0}

.countDown-btn div {text-align: center;line-height: 12px}

.countDown-btn:hover {
  border-color: #00C5B0;background-color: #00C5B0;color:#eee;
}

* /deep/ .el-dialog__body { padding-top: 5px }

.disabled-btn {pointer-events: none;color:#c0c4cc;border-color:#ebeef5}

.flex-center-center {display: flex;align-items: center;justify-content: center}

.not-select {
  -webkit-user-select:none;
  -moz-user-select:none;
  -ms-user-select:none;
  user-select:none;
}

.pop-content div, .pop-content /deep/ .el-input {width: 100% !important;}

* /deep/ .popper__arrow,.popper__arrow::after{display: none !important;}

.attention {
  color: #050505;
  line-height: 24px;
  letter-spacing: 1px;
}

.attention >>> .el-dialog__header {
  text-align: center;
}

.attention >>> .el-dialog__title {
  color: #050505;
  font-weight: bold;
}

.attention_key {
  color: #6B9731;
}

.attention_btn {
  width: 50%;
  line-height: 40px;
  margin: 25px auto 0 auto;
  color: #ffffff;
  text-align: center;
  background-color: #6B9731;
  border-radius: 4px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/goods/Detection.vue